// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  .pdf-report-wrapper {
    /*display: none !important;*/
    margin-left: 0px !important;
    margin-right: 0px !important;
    margin-bottom: 0px !important;
    width: 100% !important;
    height: 100% !important;
    overflow-x: hidden !important;
    padding: 0px !important;
  }

  .card {
    box-shadow: none;
    margin-bottom: 0px;
  }
}
html,
body {
  width: 100% !important;
  height: 100% !important;
  margin: 0px !important;
  padding: 0px !important;
  overflow-x: hidden !important;
}

.invoice-number-table {
  margin: 0 0 0 auto;
}

.invoice-number-table td {
  padding: 4px;
  border-bottom: 1px solid #000;
}

.invoice-number-table h3 {
  letter-spacing: 3px;
  margin: 0;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
